import React, { Component } from 'react';
import {
  string,
  shape,
  arrayOf,
  func,
} from 'prop-types';
import { withRouter } from 'react-router';
import { getObjectFromStaticTextArray } from 'helpers/Utils';
import withApplicationConfig from 'containers/withApplicationConfig';
import { Block, Button, Link } from 'components/common';
import { withTracking } from 'components/tracking';
import { contentGroupingsTrack } from 'components/tracking/TrackingUtils';
import _ from 'lodash';
import FaqContextualContainer, { questionWithArrow } from 'components/FAQ/FaqContextualContainer';
import ProviderHeader, {
  staticTextKeys as providerHeaderStaticTextKeys,
} from 'components/Provider/ProviderHeader/ProviderHeader';
import ErrorPage from 'pages/ErrorPage';
import BriefDescription, {
  staticTextKeys as briefDescriptionStaticTextKeys,
} from './BriefDescription/BriefDescription';
import ProviderFeaturesPanel from './ProviderFeaturesPanel/ProviderFeaturesPanel';

import './ProviderProductPage.scss';
import SeoTable from '../../../components/seo/SeoTable';

export const staticTextKeys = [
  'PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_HEADER_TEMPLATE',
  'PROVIDER_PRODUCT_PAGE_VERTICAL_LIST_HEADER_TEMPLATE',
  'CREDIT_CARDS',
  'TRAVEL_INSURANCE',
  'MORTGAGES',
  'PERSONAL_LOANS',
  'HOME_INSURANCE',
  'SECURITIES_ACCOUNT',
  'DOMESTIC_HELPER_INSURANCE',
  'PAYROLL_ACCOUNT',
  'CAR_INSURANCE',
  ...providerHeaderStaticTextKeys,
  ...briefDescriptionStaticTextKeys,
];

class ProviderProductPage extends Component {
  componentDidMount() {
    const { track } = this.props;
    contentGroupingsTrack(track, 'provider');
  }

  render() {
    const {
      providerName,
      providerImage,
      alias,
      longDescription,
      products,
      features,
      faqs,
      providers,
      staticPageText: {
        staticText: staticTextArray,
      },
      mappings,
      resultsPageRouteWithProviderAlias,
      resultsPageRouteWithoutProviderAlias,
      language,
      seoTable,
    } = this.props;

    const staticText = getObjectFromStaticTextArray(staticTextArray || []);

    const providerNameAndBriefDescHeader = _.template(
      staticText.PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_HEADER_TEMPLATE
    );

    const providerNameAndListHeader = _.template(
      staticText.PROVIDER_PRODUCT_PAGE_VERTICAL_LIST_HEADER_TEMPLATE
    );

    return (alias && (
      <div className="provider-product-page">
        <ProviderHeader
          providerImage={providerImage}
          providerName={providerName}
          alias={alias}
          providers={providers}
          staticText={staticText}
        />
        <BriefDescription
          title={providerNameAndBriefDescHeader({ providerName })}
          description={longDescription}
          staticText={staticText}
        />
        <Block>
          <Block.Header
            title={providerNameAndListHeader({ providerName })}
          />
          <div className="vertical-buttons-container">
            <div className="vertical-buttons">
              {products
                .filter(({
                  vertical: productVertical,
                }) => !(mappings[productVertical] || {}).isHidden)
                .map(({ vertical: productVertical }) => {
                  const mapping = mappings[productVertical] || {};
                  const href = _.template(
                    mapping.isRouteSkipProviderAlias
                      ? resultsPageRouteWithoutProviderAlias
                      : resultsPageRouteWithProviderAlias
                  )({
                    language,
                    vertical: mapping.route,
                    alias: mapping.isRouteSkipProviderAlias
                      ? ''
                      : alias,
                  }).replace('//', '/');
                  return (
                    <div className="vertical-button" key={productVertical}>
                      <Link to={href}>
                        <Button
                          massive
                          topIconName={mapping.iconName}
                        >
                          {staticText[productVertical]}
                        </Button>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        </Block>
        {features && features.pros && features.pros.length > 0 && (
          <ProviderFeaturesPanel
            {...features}
          />
        )}
        { seoTable && <SeoTable {...seoTable} language={language} /> }
        {faqs && faqs.faqs && (
          <div className="faq-section">
            <div className="faq-container">
              <FaqContextualContainer
                title={faqs.heading}
                faqs={faqs}
                questionRender={questionWithArrow}
                viewAllCta={faqs.viewAllCta}
              />
            </div>
          </div>
        )}
      </div>
    )) || <ErrorPage errorCode={404} />;
  }
}

ProviderProductPage.propTypes = {
  providerName: string,
  providerImage: shape({}),
  alias: string,
  longDescription: string,
  products: arrayOf(shape({})),
  features: shape({}),
  faqs: shape({}),
  providers: arrayOf(shape({})),
  staticPageText: shape({}),
  track: func,
  mappings: shape({}),
  resultsPageRouteWithProviderAlias: string,
  resultsPageRouteWithoutProviderAlias: string,
  language: string.isRequired,
  match: shape({}),
  seoTable: shape({}),
};

ProviderProductPage.defaultProps = {
  providerName: null,
  providerImage: {},
  alias: null,
  longDescription: null,
  products: [],
  features: null,
  faqs: {},
  providers: [],
  staticPageText: {},
  track: null,
  mappings: {},
  resultsPageRouteWithProviderAlias: null,
  match: {},
  seoTable: null,
};

export default withRouter(withApplicationConfig(withTracking(ProviderProductPage), ['verticals', 'routes', 'languages']));
